'use strict';

(function ($) {
  $.extend({
    debounce: function (func, wait, immediate) {
      var timeout;
      return function () {
        var _this = this;
        var args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) {
            func.apply(_this, args);
          }

        };

        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
          func.apply(_this, args);
        }

      };

    }

  });

})(jQuery);
